export const mockData = {
  // Company Info
  company: {
    name: 'Erste-Hilfe Fokus',
    phone: '+4915902268861',
    email: 'erstehilfefokus@gmail.com',
    emailInfo: 'info@erstehilfe-fokus.de',
    address: {
      street: 'Ellerstraße 53',
      zip: '40227',
      city: 'Düsseldorf',
      country: 'Deutschland',
    },
    social: {
      instagram: 'https://www.instagram.com/erstehilfe_fokus/',
      tiktok: 'https://www.tiktok.com/@erstehilfefokus',
      whatsapp: 'https://wa.me/+4915902268861',
    },
    coordinates: {
      lat: 51.2154,
      lng: 6.7858,
    },
  },
  
  // Course Types
  courseTypes: [
    {
      id: 'standard',
      name: { de: 'Erste-Hilfe-Kurs für Führerschein', en: 'First Aid Course for Driving License' },
      price: 40,
      duration: '7,5 Stunden',
      units: 9,
      includes: {
        de: ['Kursbescheinigung', 'Gratis Passbilder', 'Getränke'],
        en: ['Course certificate', 'Free passport photos', 'Drinks'],
      },
    },
    {
      id: 'bg',
      name: { de: 'BG-Kurs für Betriebe', en: 'Corporate First Aid Course' },
      price: 'Auf Anfrage',
      duration: '7,5 Stunden',
      units: 9,
      includes: {
        de: ['Kursbescheinigung', 'BG-Abrechnung', 'Individuelle Terminplanung'],
        en: ['Course certificate', 'BG billing', 'Individual scheduling'],
      },
    },
  ],
  
  // Statistics
  stats: [
    { value: '340+', label: { de: 'Google Bewertungen', en: 'Google Reviews' } },
    { value: '5.0', label: { de: 'Sterne Durchschnitt', en: 'Star Average' } },
    { value: '100%', label: { de: 'Hohe Teilnahmequote', en: 'High Participation Rate' } },
    { value: '100%', label: { de: 'Erfolgsquote', en: 'Success Rate' } },
  ],
  
  // Testimonials
  testimonials: [
    {
      name: 'Sarah M.',
      rating: 5,
      text: {
        de: 'Super Kurs! Der Kursleiter war sehr kompetent und hat alles verständlich erklärt. Die Atmosphäre war locker und angenehm.',
        en: 'Great course! The instructor was very competent and explained everything clearly. The atmosphere was relaxed and pleasant.',
      },
      date: '2025-07-15',
    },
    {
      name: 'Michael K.',
      rating: 5,
      text: {
        de: 'Sehr empfehlenswert! Praxisnah und informativ. Die Passbilder waren ein netter Bonus.',
        en: 'Highly recommended! Practical and informative. The passport photos were a nice bonus.',
      },
      date: '2025-07-20',
    },
    {
      name: 'Anna L.',
      rating: 5,
      text: {
        de: 'Toller Kurs in entspannter Atmosphäre. Ich fühle mich jetzt sicher, im Notfall helfen zu können.',
        en: 'Great course in a relaxed atmosphere. I now feel confident to help in an emergency.',
      },
      date: '2025-07-25',
    },
  ],
  
  // Partners
  partners: [
    { name: 'Med1Plus', logo: '/images/partners/med1plus.svg' },
    { name: 'DGUV', logo: '/images/partners/dguv.svg' },
  ],
  
  // Image URLs
  images: {
    logo: 'https://customer-assets.emergentagent.com/job_0dec4274-1005-4c79-97c3-d89a349d46d4/artifacts/lox8xm99_IMG_1076.png',
    hero: 'https://customer-assets.emergentagent.com/job_firstaid-focus/artifacts/vhs3fsny_4c0ebcac-9266-4c7a-88d4-de06070e78c1.jpg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_firstaid-focus/artifacts/lfzj0j56_1afa404b-e211-4ab5-9aca-d70b35cc2000.jpg',
      'https://customer-assets.emergentagent.com/job_firstaid-focus/artifacts/pb84jtfq_61487a07-1279-42ad-970b-997be1387d28-p-800.jpg',
      'https://customer-assets.emergentagent.com/job_firstaid-focus/artifacts/qk8jt778_39002381-63a1-4aa5-b262-00013876c33d.jpg',
      'https://customer-assets.emergentagent.com/job_firstaid-focus/artifacts/4skur3ka_e4d6bc74-1838-42c0-88c2-342c595fdb3e-p-500.jpg',
    ],
  },
  
  // Booking URL
  bookingUrl: 'https://erstehilfe-fokus.de/buchungssystem/index.php',
};
